export enum InfoTypes {
    SEARCH = "SEARCH",
    INFODOWNLOAD = "INFODOWNLOAD",
}